<template>
    <td :colspan="colspan" class="text-center">
      <i class="fas fa-database" aria-hidden="true"></i>
      <span class="ml-1">Empty List</span>
    </td>
</template>

<script>
export default {
  name: "EmptyTableRow",
  props: {
    colspan: {
      type: Number,
      default: 8,
    },
  },
};
</script>
